const wrapper = "_uxsw1crhdua";
const heading = "_uxshdqbea7";

export { heading, wrapper };
import "./atom.task.style.linaria.module.css";
//# sourceMappingURL=atom.task.style.js.map
